// Copyright 2019 Stanford University see LICENSE for license

// Formerly fetched at runtime from
// https://ld4p.github.io/sinopia/help_and_resources/menu_content.html and
// injected with dangerouslySetInnerHTML. Kept here so the menu is reviewed
// with the code and no third-party markup reaches the page.
const helpMenuSections = [
  {
    heading: "Help",
    links: [
      {
        label: "Blue Core help site",
        href: "https://github.com/blue-core-lod/blue-core/wiki",
      },
      {
        label: "Report a bug",
        href: "https://github.com/blue-core-lod/sinopia_editor/issues/new?assignees=&labels=BFF%2C+bug&template=bug_report.md&title=",
      },
      {
        label: "Suggest a new feature",
        href: "https://github.com/blue-core-lod/sinopia_editor/issues/new?assignees=&labels=BFF%2C+enhancement&template=feature_request.md&title=",
      },
      {
        label: "Release Notes",
        href: "https://github.com/blue-core-lod/sinopia_editor/releases/latest",
      },
      {
        label: "Lookups & QA help",
        href: "https://github.com/LD4P/qa_server/wiki/Authority-Lookup-Support-Plan-for-Sinopia",
      },
    ],
  },
  {
    heading: "Communication",
    links: [
      {
        label: "User group meetings",
        href: "https://docs.google.com/document/d/1-veUbkfJ-1YUfeXv5E6efBSY7iucyajamLl239MCnPo/",
      },
      {
        label: "User group mailing list",
        href: "https://groups.google.com/g/sinopia-users",
      },
      {
        label: "Slack channel #sinopia",
        href: "https://ld4.slack.com/messages/#sinopia",
      },
      {
        label: "Join ld4 Slack workspace",
        href: "http://bit.ly/ld4slack",
      },
    ],
  },
  {
    heading: "Training Resources",
    links: [
      {
        label: "PCC Training Modules",
        href: "https://www.loc.gov/catworkshop/Sinopia-Training/index.html",
      },
    ],
  },
]

export default helpMenuSections
